module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/LAW-dd5bed4bfc138a0a1a46482846793011.png";